module.exports = __webpack_public_path__ + "img/img4.f1718821.svg";